module.exports = __webpack_public_path__ + "static/media/korea01.af661103.jpg";